import { useCallback, useMemo } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { getNextPath } from './entryParams'

/**
 * Where an entry link asked to go after sign-in (?next=...&renewalId=...),
 * and a function that goes there.
 *
 *   nextPath        the allowed in-app path, or null (see entryParams)
 *   continueToNext  navigates to nextPath and returns true, or returns false
 *                   when there is nowhere to continue to. replace, not push,
 *                   and with an empty search, so the entry params do not stay
 *                   in history.
 *
 * Call it only once the member is signed in.
 */
const useEntryContinuation = () => {
    const location = useLocation()
    const history = useHistory()
    const nextPath = useMemo(() => getNextPath(location.search), [location.search])

    const continueToNext = useCallback(() => {
        if (!nextPath) { return false }
        history.replace({ pathname: nextPath, search: '' })
        return true
    }, [history, nextPath])

    return { nextPath, continueToNext }
}

export default useEntryContinuation
